import $ from 'jquery'
import trackEvent from '@app/utils/track_event'

$(document).on('click', "[data-behaviour~='click-track-event']", function () {
  const data = $(this).data()

  const [category, action, label] = data.event.split(',')

  if (category && action && label) {
    trackEvent(category, action, label)
  }
})
